import { render, staticRenderFns } from "./BatchResultView.vue?vue&type=template&id=6be3ed52&scoped=true&"
import script from "./BatchResultView.vue?vue&type=script&lang=js&"
export * from "./BatchResultView.vue?vue&type=script&lang=js&"
import style0 from "./BatchResultView.vue?vue&type=style&index=0&id=6be3ed52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3ed52",
  null
  
)

export default component.exports